import Modal from "../../../../../../../../../../../components/Modal/Modal";
import Button from "../../../../../../../../../../../components/Button/Button";
import DeleteTrashOpenIcon from "../../../../../../../../../../../assets/svg/delete-trash-open-icon";

interface DeleteCommentModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirmDelete: () => Promise<void>;
  isDeleting: boolean;
}

const DeleteCommentModal = ({
  open,
  onOpenChange,
  onConfirmDelete,
  isDeleting,
}: DeleteCommentModalProps) => {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      preventOutsideClick={isDeleting}
      showHeader={false}
      contentClassName="w-[250px] border border-border-gray dark:border-border-gray-dk bg-fixed-white dark:bg-popper-bg-dk backdrop-blur-[10px]"
      overlayClassName="bg-black/80"
      bodyClassName="!p-4"
    >
      <div className="flex flex-col items-center gap-4">
        <div className="w-[36px] h-[36px] bg-analytics-red/10 dark:bg-analytics-red-dk/10 rounded-full flex items-center justify-center shrink-0">
          <DeleteTrashOpenIcon className="w-5 h-5 text-verba-red-alert dark:text-verba-red-alert-dk" />
        </div>

        <div className="flex flex-col items-center gap-1 text-center mb-2">
          <h3 className="text-heading-text dark:text-heading-text-dk font-bold text-md">
            Delete Comment
          </h3>
          <p className="text-sm font-normal text-heading-text dark:text-heading-text-dk">
            Are you sure you want to delete this comment?
          </p>
        </div>

        <div className="flex items-center justify-center gap-3 w-full">
          <Button
            innerText="Cancel"
            onClick={() => onOpenChange(false)}
            disabled={isDeleting}
            buttonContainerClass="flex- min-w-[110px] py-1 px-2 border border-verba-indigo dark:border-verba-indigo-dk bg-verba-indigo dark:bg-verba-indigo-dk rounded-[8px] cursor-pointer"
            innerTextClass="text-pure-white dark:text-pure-white-dk text-md font-semibold"
          />
          <Button
            innerText="Delete"
            onClick={onConfirmDelete}
            disabled={isDeleting}
            isLoading={isDeleting}
            buttonContainerClass="min-w-[110px] disabled:opacity-30 py-1 border border-verba-red-alert dark:border-verba-red-alert-dk bg-transparent dark:bg-transparent rounded-[8px] cursor-pointer"
            innerTextClass="text-verba-red-alert dark:text-verba-red-alert-dk text-md font-semibold"
            loaderColor="text-verba-red-alert dark:text-verba-red-alert-dk"
            loaderSize={15}
          />
        </div>
      </div>
    </Modal>
  );
};

export default DeleteCommentModal;
